import * as angular from 'angular';
import { NotificationConstants } from 'angular/constants/NotificationConstants';
import { Decimal } from 'decimal.js';
import * as moment from 'pkp-moment-timezone-all-years';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import {
    findLeadTimeRule,
    leadTimeExpirationDateHint,
    LeadTimeMode
} from 'app/create-proposal/lead-time-utils';

type RuntimeAndTransactionType = {
    transactionType: 'TRANSFER_OF_USE' | 'ASSIGNMENT';
    runtimeStart: moment.Moment | Date;
    runtimeEnd: moment.Moment | Date;
};

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'CreateProposalStageThreeCtrl',
            CreateProposalStageThreeCtrl
        );

    function CreateProposalStageThreeCtrl(
        $scope,
        $translate,
        $timeout,
        createProposalService,
        TraderList,
        TradeCondition,
        Shipper,
        TradeProposals,
        bigDecimalConverterService,
        $rootScope,
        platformSettingsService,
        INCLUDE,
        TransmissionSystemOperator: TransmissionSystemOperatorResource
    ) {
        var vm = this;

        vm.INCLUDE = INCLUDE;
        vm.getEic = createProposalService.getEic;
        vm.submit = submit;
        vm.INTENTION = createProposalService.INTENTION;
        vm.PROCEDURE = createProposalService.PROCEDURE;
        vm.TRANSACTION_TYPE = createProposalService.TRANSACTION_TYPE;
        vm.capacityUnits = createProposalService.capacityUnits;
        vm.minLotRuntimeUnits = createProposalService.minLotRuntimeUnits;

        init();

        function init() {
            vm.ui = {
                addNewTradingCondition: false,
                isSubmissionWindowLeadTime0Valid: true,
                isSubmissionWindowLeadTime1Valid: true,
                isExpirationDateLeadTime0Valid: true,
                isExpirationDateLeadTime1Valid: true,
                leadTime: {
                    checking: false,
                    violation: false,
                    violationMessage:
                        'Please check your form. We found a lead time violation.'
                }
            };
            vm.data = createProposalService.getStageThree();
            vm.networkPoint =
                createProposalService.getStageOne().selectedNetworkPoint;
            vm.tsoConfig = createProposalService.getStageOne().tsoConfig;
            vm.supportedLotRuntimeTypes = vm.tsoConfig.supportedLotRuntimeTypes;
            vm.minimumTradeRuntime = getMinimumRuntime();
            vm.isIntentionSell =
                createProposalService.getStageTwo().intention ===
                vm.INTENTION.SELL;

            vm.isSupporting = {
                OTC: false,
                FCFS: false,
                CFO: false,
                assigment: false,
                transferOfUse: false
            };

            if (angular.isUndefined(vm.data.anonymous)) {
                vm.data.anonymous = false;
            }

            if (!angular.isUndefined(vm.tsoConfig.supportedTradingProcedures)) {
                var intention = vm.isIntentionSell ? 'SELL' : 'BUY';
                for (
                    var i = 0;
                    i < vm.tsoConfig.supportedTradingProcedures.length;
                    i++
                ) {
                    var supportedProcedure =
                        vm.tsoConfig.supportedTradingProcedures[i];
                    if (supportedProcedure === vm.PROCEDURE.OTC) {
                        vm.isSupporting.OTC = true;
                    }
                    if (
                        supportedProcedure ===
                        vm.PROCEDURE.FCFS + '_' + intention
                    ) {
                        vm.isSupporting.FCFS = true;
                    }
                    if (
                        supportedProcedure ===
                        vm.PROCEDURE.CFO + '_' + intention
                    ) {
                        vm.isSupporting.CFO = true;
                    }
                }
            }

            if (!angular.isUndefined(vm.tsoConfig.supportedTransactionTypes)) {
                for (
                    var y = 0;
                    y < vm.tsoConfig.supportedTransactionTypes.length;
                    y++
                ) {
                    switch (vm.tsoConfig.supportedTransactionTypes[y]) {
                        case vm.TRANSACTION_TYPE.ASSIGNMENT: {
                            vm.isSupporting.assigment = true;
                            break;
                        }
                        case vm.TRANSACTION_TYPE.TRANSFER: {
                            vm.isSupporting.transferOfUse = true;
                            break;
                        }
                    }
                }
            }

            initOffer();
            initRules();
            initCounterparty();
            updateOfferPrice();

            $scope.$watch(
                function () {
                    return vm.data.anonymous;
                },
                function () {
                    updateOfferPrice();
                }
            );

            $scope.$watchGroup(
                [
                    function () {
                        return vm.data.rules.submissionWindowClosure;
                    },
                    function () {
                        return vm.data.rules.expirationDate;
                    },
                    function () {
                        if (vm.data.offer.runtime) {
                            return vm.data.offer.runtime.start;
                        }
                    },
                    function () {
                        if (vm.data.offer.runtime) {
                            return vm.data.offer.runtime.end;
                        }
                    }
                ],
                function () {
                    if (
                        vm.form &&
                        vm.form.$valid &&
                        vm.tsoConfig &&
                        isLeadTimesHasToBeChecked()
                    ) {
                        checkLeadTimes();
                    } else {
                        vm.ui.isSubmissionWindowLeadTime0Valid = true;
                        vm.ui.isExpirationDateLeadTime0Valid = true;
                        vm.ui.isSubmissionWindowLeadTime1Valid = true;
                        vm.ui.isExpirationDateLeadTime1Valid = true;
                        vm.ui.leadTime.violation = false;
                    }
                    validateMinimumTradeRuntime();
                }
            );

            $scope.$watchGroup(
                [
                    function () {
                        return vm.data.counterparty.shipper;
                    },
                    function () {
                        return vm.data.counterparty.eic;
                    }
                ],
                function () {
                    validateCounterpartySelection();
                }
            );

            $scope.$watch(
                function () {
                    return vm.data.offer.price.originalUnit;
                },
                function () {
                    updateExchangeRate();
                }
            );

            vm.ui.isMinimumTradeRuntimeValid = true;

            TraderList.specificQuery({}, function (res) {
                vm.traderLists = res;
            });

            vm.tsoLeadTimeRules = [];
            vm.expirationDateHint = undefined;

            [vm.networkPoint.tso0Id, vm.networkPoint.tso1Id].forEach(
                (id, idx) => {
                    if (id == null) return;
                    TransmissionSystemOperator.getSecondarySettings(
                        { id },
                        (res) => {
                            vm.tsoLeadTimeRules[idx] = res['leadTimeRules'];
                        },
                        (err) => {
                            console.error(
                                'TransmissionSystemOperator.getSecondarySettings error',
                                { id, err }
                            );
                            delete vm.tsoLeadTimeRules[idx];
                        }
                    );
                }
            );

            $scope.$watch(
                () => ({
                    transactionType: vm.data.transactionType,
                    runtimeStart: vm.data.offer.runtime
                        ? vm.data.offer.runtime.start
                        : undefined,
                    runtimeEnd: vm.data.offer.runtime
                        ? vm.data.offer.runtime.end
                        : undefined
                }),
                (newValue: RuntimeAndTransactionType) => {
                    vm.expirationDateHint = undefined;
                    if (
                        !newValue.transactionType ||
                        !(newValue.runtimeStart instanceof Date) ||
                        !(newValue.runtimeEnd instanceof Date)
                    )
                        return;
                    const runtime = {
                        start: newValue.runtimeStart,
                        end: newValue.runtimeEnd
                    };
                    const selectedRules = (vm.tsoLeadTimeRules as any[]).map(
                        (leadTimeRules) =>
                            findLeadTimeRule({
                                leadTimeRules,
                                runtime,
                                mode: ('SECONDARY_' +
                                    newValue.transactionType) as LeadTimeMode
                            })
                    );
                    const rules = selectedRules
                        .map((selectedRule, idx) => ({
                            rule: selectedRule,
                            tso: vm.networkPoint[`tso${idx}ShortName`]
                        }))
                        .filter((r) => r.rule);
                    vm.expirationDateHint = leadTimeExpirationDateHint({
                        runtime,
                        rules
                    });
                },
                true
            );

            fetchTradingConditions();

            Shipper.queryPublic({}, function (res) {
                vm.publicShippers = res.data;
            });

            $rootScope.$on(
                platformSettingsService.BROADCAST.ADDED_CONDITION,
                function (event, conditionName) {
                    fetchTradingConditions().then(function () {
                        for (var i = 0; i < vm.conditionsList.length; i++) {
                            var condition = vm.conditionsList[i];
                            if (condition.name === conditionName) {
                                vm.data.rules.conditions = condition;
                            }
                        }
                    });
                    $timeout(function () {
                        vm.ui.addNewTradingCondition = false;
                    }, NotificationConstants.duration);
                }
            );
        }

        function updateExchangeRate() {
            if (
                !angular.isUndefined(vm.tsoConfig.tso0Config) &&
                !angular.isUndefined(vm.tsoConfig.tso0Config.exchangeRate)
            ) {
                updateExchangeRateFromTso(vm.tsoConfig.tso0Config.exchangeRate);
            }
            if (
                !angular.isUndefined(vm.tsoConfig.tso1Config) &&
                !angular.isUndefined(vm.tsoConfig.tso1Config.exchangeRate)
            ) {
                updateExchangeRateFromTso(vm.tsoConfig.tso1Config.exchangeRate);
            }
        }

        function updateExchangeRateFromTso(xchgRate) {
            if (
                !angular.isUndefined(vm.data.offer.price.originalUnit) &&
                vm.data.offer.price.originalUnit.currency === xchgRate.isoCode
            ) {
                vm.exchangeRate = {
                    value: xchgRate.rate,
                    unit: 'EUR/' + xchgRate.isoCode,
                    date: moment(xchgRate.validity.start).format(
                        'DD.MM.YYYY HH:mm'
                    )
                };
            }
        }

        function validateCounterpartySelection() {
            if (vm.data.procedure === vm.PROCEDURE.OTC) {
                if (
                    !vm.data.counterparty.shipper &&
                    vm.data.counterparty.eic === ''
                ) {
                    vm.ui.isCounterpartySelectionValid = false;
                } else {
                    vm.ui.isCounterpartySelectionValid = true;
                }
            } else {
                vm.ui.isCounterpartySelectionValid = true;
            }
            evaluteError(
                vm.ui.isCounterpartySelectionValid,
                vm.form.counterpartyShipper,
                'counterpartyValidation'
            );
            return vm.ui.isCounterpartySelectionValid;
        }

        function fetchTradingConditions() {
            return TradeCondition.query(
                { includePlatformConditions: true },
                function (res) {
                    vm.conditionsList = res;
                }
            ).$promise;
        }

        function continueToNextStep() {
            prepareDataOnOTC();
            createProposalService.setStageThree(vm.data);
            $scope.wizard.goToNextStage();
        }

        function submit(form: ng.IFormController) {
            var isCounterpartySelectionValid = validateCounterpartySelection();
            var isMinimumTradeRuntimeValid = validateMinimumTradeRuntime();
            var isProcedureSelected = !angular.isUndefined(vm.data.procedure);

            if (
                !form.$valid ||
                !isCounterpartySelectionValid ||
                !isMinimumTradeRuntimeValid ||
                !isProcedureSelected
            ) {
                $scope.wizard.goToTop();
                return false;
            }

            if (isLeadTimesHasToBeChecked()) {
                var promise = checkLeadTimes();
                if (!angular.isUndefined(promise)) {
                    promise.finally(function () {
                        if (vm.ui.leadTime.violation) {
                            $scope.wizard.goToTop();
                            return false;
                        } else {
                            continueToNextStep();
                        }
                    });
                }
            } else {
                continueToNextStep();
            }
        }

        function getSecondaryType() {
            return vm.isIntentionSell ? 'offer' : 'request';
        }

        function prepareDataOnOTC() {
            if (vm.data.procedure == vm.PROCEDURE.OTC) {
                vm.data.rules.completeLotRuntime = false;
                delete vm.data.rules.minLotRuntime;
                delete vm.data.rules.minLotSize.originalValue;
            }
        }

        function validateMinimumTradeRuntime() {
            if (!vm.data.offer.runtime) {
                return;
            }

            var runtimeStart = moment(vm.data.offer.runtime.start);
            var runtimeEnd = moment(vm.data.offer.runtime.end);

            var errors0 = checkMinimumTradeRuntime(
                runtimeStart,
                runtimeEnd,
                vm.tsoConfig.tso0Config
            );
            var errors1 = [];

            if (!angular.isUndefined(vm.tsoConfig.tso1Config)) {
                errors1 = checkMinimumTradeRuntime(
                    runtimeStart,
                    runtimeEnd,
                    vm.tsoConfig.tso1Config
                );
            }

            var errors = removeDoubles(errors0.concat(errors1));
            vm.ui.isMinimumTradeRuntimeValid = errors.length === 0;
            vm.ui.isMinimumTradeRuntimeValidityMessages = errors.join('<br/>');

            return vm.ui.isMinimumTradeRuntimeValid;
        }

        function checkMinimumTradeRuntime(runtimeStart, runtimeEnd, tsoConfig) {
            var periodType = tsoConfig.minimumTradeRuntime.type;
            var minimum = tsoConfig.minimumTradeRuntime.value;

            var checkStartResult = checkRuntimeType(
                'start',
                runtimeStart,
                periodType
            );
            var checkEndResult = checkRuntimeType(
                'end',
                runtimeEnd,
                periodType
            );
            var checkIntervalSizeResult = checkIntervalSize(
                runtimeStart,
                runtimeEnd,
                periodType,
                minimum
            );

            var errors = [];
            if (checkStartResult !== '') {
                errors.push(checkStartResult);
            }
            if (checkEndResult !== '') {
                errors.push(checkEndResult);
            }
            if (checkIntervalSizeResult !== '') {
                errors.push(checkIntervalSizeResult);
            }
            return errors;
        }

        function checkRuntimeType(key, runtimePoint, periodType) {
            var result = '';
            switch (periodType) {
                case 'HOUR': {
                    if (!isFullHour(runtimePoint)) {
                        result = 'The runtime ' + key + ' is not a full hour';
                    }
                    break;
                }
                case 'DAY': {
                    if (!isGasDay(runtimePoint)) {
                        result = 'The runtime ' + key + ' is not a gas day';
                    }
                    break;
                }
                case 'MONTH': {
                    if (!isGasMonth(runtimePoint)) {
                        result = 'The runtime ' + key + ' is not a gas month';
                    }
                    break;
                }
                default: {
                    result =
                        'The configured period type is invalid: ' + periodType;
                }
            }
            return result;
        }

        function checkIntervalSize(
            runtimeStart,
            runtimeEnd,
            periodType,
            minimum
        ) {
            var result = '';
            switch (periodType) {
                case 'HOUR': {
                    if (durationInHours(runtimeStart, runtimeEnd) < minimum) {
                        result =
                            'The proposal runtime is smaller than the minimum trade runtime: ' +
                            minimum +
                            ' hour(s)';
                    }
                    break;
                }
                case 'DAY': {
                    if (durationInDays(runtimeStart, runtimeEnd) < minimum) {
                        result =
                            'The proposal runtime is smaller than the minimum trade runtime: ' +
                            minimum +
                            ' day(s)';
                    }
                    break;
                }
                case 'MONTH': {
                    if (durationInMonths(runtimeStart, runtimeEnd) < minimum) {
                        result =
                            'The proposal runtime is smaller than the minimum trade runtime: ' +
                            minimum +
                            ' month(s)';
                    }
                    break;
                }
                default: {
                    result =
                        'The configured period type is invalid: ' + periodType;
                }
            }
            return result;
        }

        function isFullHour(date) {
            var dateCet = moment(date);
            return (
                dateCet.minute() === 0 &&
                dateCet.second() === 0 &&
                dateCet.millisecond() === 0
            );
        }

        function isGasDay(date) {
            var dateCet = moment(date);
            return dateCet.hour() === 6 && isFullHour(dateCet);
        }

        function isGasMonth(date) {
            var dateCet = moment(date);
            return dateCet.date() === 1 && isGasDay(dateCet);
        }

        function durationInHours(start, end) {
            return end.diff(start, 'hours');
        }

        function durationInDays(start, end) {
            return end.diff(start, 'days');
        }

        function durationInMonths(start, end) {
            return end.diff(start, 'months');
        }

        function removeDoubles(array) {
            var result = [];
            angular.forEach(array, function (value) {
                if (result.indexOf(value) < 0) {
                    result.push(value);
                }
            });
            return result;
        }

        function isLeadTimesHasToBeChecked() {
            if (vm.tsoConfig.intraDayProposalAllowed) {
                var now = moment();
                var runtimeStart = moment(vm.data.offer.runtime.start);
                var isRuntimeStartInPast = runtimeStart.isBefore(now, 'minute');
                return !isRuntimeStartInPast;
            }

            return true;
        }

        function evaluteError(isValid, formElement, msg) {
            return createProposalService.evaluteError(
                isValid,
                formElement,
                msg
            );
        }

        function checkLeadTimes() {
            var expirationDate = vm.data.rules.expirationDate;
            var submissionClosure = vm.data.rules.submissionWindowClosure;

            if (
                angular.equals({}, expirationDate) ||
                (vm.data.procedure === vm.PROCEDURE.CFO &&
                    angular.equals({}, submissionClosure)) ||
                angular.isUndefined(vm.data.transactionType) ||
                angular.isUndefined(vm.data.offer.runtime.start) ||
                angular.isUndefined(vm.data.offer.runtime.end)
            ) {
                return;
            }

            vm.ui.leadTime.checking = true;
            vm.ui.leadTime.violation = false;

            var data = {
                networkPointId: vm.networkPoint.id,
                expirationDate: expirationDate,
                submissionClosure: !angular.equals({}, submissionClosure)
                    ? submissionClosure
                    : undefined,
                transactionType: vm.data.transactionType,
                runtimeStart: vm.data.offer.runtime.start,
                runtimeEnd: vm.data.offer.runtime.end
            };

            var promise = TradeProposals.checkLeadTimes(data, function (res) {
                vm.ui.leadTime.result = res;

                var submissionClosureValid =
                    vm.data.procedure !== vm.PROCEDURE.CFO ||
                    (vm.networkPoint.bundled
                        ? res.submissionClosureValid0 &&
                          res.submissionClosureValid1
                        : res.submissionClosureValid0);
                var expirationDateValid = vm.networkPoint.bundled
                    ? res.expirationDateValid0 && res.expirationDateValid1
                    : res.expirationDateValid0;

                vm.ui.isSubmissionWindowLeadTime0Valid =
                    res.submissionClosureValid0;
                vm.ui.isExpirationDateLeadTime0Valid = res.expirationDateValid0;
                if (vm.networkPoint.bundled) {
                    vm.ui.isSubmissionWindowLeadTime1Valid =
                        res.submissionClosureValid1;
                    vm.ui.isExpirationDateLeadTime1Valid =
                        res.expirationDateValid1;
                }

                vm.ui.leadTime.violation = !(
                    submissionClosureValid && expirationDateValid
                );
            }).$promise;

            promise.finally(function () {
                vm.ui.leadTime.checking = false;
            });

            return promise;
        }

        function initOffer() {
            if (angular.isUndefined(vm.data.offer)) {
                vm.data.offer = {};
            }

            initRuntime(vm.data.offer);

            if (angular.isUndefined(vm.data.offer.capacity)) {
                var unit = 'kWh/d';
                if (vm.networkPoint.physicalUnit === 'K_WH_H') {
                    unit = 'kWh/h';
                }
                if (vm.networkPoint.physicalUnit === 'M3_H') {
                    unit = $translate
                        .instant('PhysicalUnit.' + vm.networkPoint.physicalUnit)
                        .replace('&#179;', '³');
                }
                vm.data.offer.capacity = {
                    unit: unit
                };
            }
            if (
                angular.isUndefined(vm.data.offer.price) ||
                vm.data.offer.price === null
            ) {
                vm.data.offer.price = {
                    originalUnit: vm.tsoConfig.supportedPriceUnits[0]
                };
            }
        }

        function initRuntime(offer) {
            if (angular.isUndefined(offer.runtime)) {
                var todayGasDayStart = moment()
                    .hour(6)
                    .minute(0)
                    .second(0)
                    .millisecond(0);
                offer.runtime = {
                    start: angular.copy(todayGasDayStart).add(1, 'days'),
                    end: angular.copy(todayGasDayStart).add(2, 'days')
                };
            }
        }

        function initCounterparty() {
            if (angular.isUndefined(vm.data.counterparty)) {
                vm.data.counterparty = {};
            }

            if (angular.isUndefined(vm.data.counterparty.shipper)) {
                vm.data.counterparty.shipper = null;
            }

            if (angular.isUndefined(vm.data.counterparty.eic)) {
                vm.data.counterparty.eic = '';
            }
        }

        function initRules() {
            if (angular.isUndefined(vm.data.rules)) {
                vm.data.rules = {};
            }
            if (angular.isUndefined(vm.data.rules.runtime)) {
                vm.data.rules.runtime = {};
            }
            if (angular.isUndefined(vm.data.rules.completeLotRuntime)) {
                vm.data.rules.completeLotRuntime = false;
            }
            if (angular.isUndefined(vm.data.rules.minLotSize)) {
                vm.data.rules.minLotSize = {
                    originalUnit: $translate
                        .instant('PhysicalUnit.' + vm.networkPoint.physicalUnit)
                        .replace('&#179;', '³')
                };
            }
            if (angular.isUndefined(vm.data.rules.minLotRuntime)) {
                if (!angular.isUndefined(vm.minimumTradeRuntime)) {
                    vm.data.rules.minLotRuntime = {
                        unit: vm.minimumTradeRuntime.type,
                        value: vm.minimumTradeRuntime.value
                    };
                } else {
                    if (angular.isUndefined(vm.supportedLotRuntimeTypes)) {
                        vm.supportedLotRuntimeTypes = Object.keys(
                            vm.minLotRuntimeUnits
                        );
                    }
                    vm.data.rules.minLotRuntime = {
                        value: 1,
                        unit: vm.supportedLotRuntimeTypes[0]
                    };
                }
            }
            if (angular.isUndefined(vm.data.rules.restrictParticipates)) {
                vm.data.rules.restrictParticipates = false;
            }
            if (angular.isUndefined(vm.data.rules.submissionWindowClosure)) {
                vm.data.rules.submissionWindowClosure = null;
            }
            if (angular.isUndefined(vm.data.rules.expirationDate)) {
                vm.data.rules.expirationDate = null;
            }
        }

        function updateOfferPrice() {
            if (
                vm.data.anonymous &&
                !angular.isUndefined(vm.data.offer.price) &&
                vm.data.offer.price !== null
            ) {
                vm.data.offer.price.originalValue = {};
                vm.data.offer.price.originalValue[
                    bigDecimalConverterService.VALUE_KEY_NAME
                ] = new Decimal(0);
                vm.data.offer.price.originalValue[
                    bigDecimalConverterService.FLAG_KEY_NAME
                ] = true;
            }
        }

        function getMinimumRuntime() {
            if (
                !!vm.tsoConfig.tso0Config &&
                !!vm.tsoConfig.tso1Config &&
                !!vm.tsoConfig.tso0Config.minimumTradeRuntime &&
                !!vm.tsoConfig.tso1Config.minimumTradeRuntime
            ) {
                var result = calculateMinimumRuntime(
                    vm.tsoConfig.tso0Config.minimumTradeRuntime,
                    vm.tsoConfig.tso1Config.minimumTradeRuntime
                );
                return result;
            }
            return vm.tsoConfig.tso0Config.minimumTradeRuntime;
        }

        function calculateMinimumRuntime(
            minimumTradeRuntime0,
            minimumTradeRuntime1
        ) {
            var periodType0AsNumber = convertPeriodTypeToNumber(
                minimumTradeRuntime0.type
            );
            var periodType1AsNumber = convertPeriodTypeToNumber(
                minimumTradeRuntime1.type
            );
            if (periodType0AsNumber === periodType1AsNumber) {
                if (minimumTradeRuntime0.value < minimumTradeRuntime1.value) {
                    return minimumTradeRuntime1;
                } else {
                    return minimumTradeRuntime0;
                }
            } else {
                if (periodType0AsNumber < periodType1AsNumber) {
                    return minimumTradeRuntime1;
                } else {
                    return minimumTradeRuntime0;
                }
            }
        }

        function convertPeriodTypeToNumber(periodType) {
            var result;
            switch (periodType) {
                case 'HOUR': {
                    result = 1;
                    break;
                }
                case 'DAY': {
                    result = 2;
                    break;
                }
                case 'MONTH': {
                    result = 3;
                    break;
                }
                default: {
                    result = NaN;
                }
            }
            return result;
        }
    }
})();
